import React from 'react'
import { observer } from 'mobx-react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from 'components/StickyViewHeader'
import WorkspaceFilterViewHeading from 'components/WorkspaceFilterViewHeading'
import { ScrollOffsetInterpolation } from 'hooks/spring-hooks'
import BookkeepingManagerViewModel from 'admin/bookkeeping/BookkeepingManagerViewModel'

interface BookkeepingManagerHeaderProps {
  scrollOffset: ScrollOffsetInterpolation
  vm: BookkeepingManagerViewModel
}

export default observer(function BookkeepingManagerHeader({
  vm,
  scrollOffset,
}: BookkeepingManagerHeaderProps) {
  const searcher = vm.searcher
  return (
    <StickyViewHeader scrollOffset={scrollOffset}>
      <StickyViewHeaderMain>
        <WorkspaceFilterViewHeading
          allOptionText="All workspaces"
          primaryText="Bookkeeping manager"
          filter={searcher.workspaceFilter}
        />
      </StickyViewHeaderMain>
    </StickyViewHeader>
  )
})
